// types
import { AccountBalance, Loan } from '../../../@types';
import { AmountsValue } from './Amounts';

export interface ConstructAmountInputsProps {
	balances?: AccountBalance[];
	loans?: Loan[];
	values?: AmountsValue[];
}

export const constructAmountInputs = ({ balances, loans, values }: ConstructAmountInputsProps) => {
	if (values) {
		return values.map((value) => {
			return {
				amount: value.amount || 0,
				loan: value.loan,
				tax: value.tax || 0,
			};
		});
	} else if (balances) {
		return balances.map((balance: AccountBalance) => {
			const loan = balance.loan as Loan;
			return {
				balance: balance.balance,
				disabled: loan?.status === 'DISABLED',
				loan,
			};
		});
	} else if (loans) {
		return loans.map((loan: Loan) => {
			return {
				disabled: loan?.status === 'DISABLED',
				loan,
			};
		});
	}

	return [];
};
